import axios from 'axios';
import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import {
  plates,
  getPlatesError,
  getPlatesSuccess,
  assignPlateMukebSuccess,
  getPlates,
  assignPlateMukebError,
  cancelPlateError,
  cancelPlateSuccess,
  exportPlatesExcelError,
  exportPlatesExcelSuccess,
} from './actions';
import {
  ASSIGN_PLATE_MUKEB,
  CANCEL_PLATE,
  EXPORT_PLATES_EXCEL,
  GET_PLATES,
} from 'redux/actions';

const getPlatesAsync = async (page = 1, filters = {}) => {
  const query = new URLSearchParams({
    page,
    perpage: '200',
    ...filters,
  }).toString();
  const { data } = await axios.get(`/area-plate-axes/search?${query}`);
  return data;
};

const exportPlatesAsync = async (filters = {}, type = 'excel') => {
  const query = new URLSearchParams(filters).toString();
  const { data } = await axios.get(`/area-plate-axes/export/${type}?${query}`, {
    responseType: type === 'excel' ? 'blob' : 'json',
  });
  return data;
};

const assignPlateMukebAsync = async ({
  plateId,
  mukebId,
  type,
  reserveType,
  standType,
}) => {
  const { data } = await axios.put(`/area-plate-axes/change/${plateId}`, {
    mukeb_id: mukebId,
    type,
    reserve_type: reserveType,
    stand: standType,
  });
  return data;
};

const cancelPlateAsync = async (plateId) => {
  const { data } = await axios.put(`/area-plate-axes/cancel/${plateId}`);
  return data;
};

function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(url);
}

function* errorHandler(error, errorAction) {
  try {
    if ('response' in error) {
      const { response } = error;

      if (response?.data?.message) {
        yield put(errorAction(response.data.message));
        return;
      }

      if (response?.data?.errors) {
        const keys = Object.keys(response.data.errors);
        for (const key of keys) {
          const message =
            response.data.errors[key][0] || 'خطا در انجام عملیات.';
          yield put(errorAction(message));
        }
        return;
      }
    }

    yield put(
      errorAction('خطا در ارتباط با سرور. لطفاً اتصال خود را بررسی کنید.')
    );
  } catch {
    yield put(errorAction('خطایی در انجام فرآیند رخ داد.'));
  }
}

function* getPlatesSaga(action) {
  const { page = 1, filters = {} } = action.payload || {};
  try {
    const data = yield call(getPlatesAsync, page, filters);
    yield put(plates(data));
    yield put(getPlatesSuccess('محور‌ها با موفقیت دریافت شدند.'));
  } catch (error) {
    yield call(errorHandler, error, getPlatesError);
  }
}

function* assignPlateMukebSaga(action) {
  try {
    const { plateId, mukebId, type, reserveType, standType, page, filters } =
      action.payload;
    yield call(assignPlateMukebAsync, { plateId, mukebId, type, reserveType, standType });
    yield put(assignPlateMukebSuccess('پلاک با موفقیت تخصیص داده شد.'));
    yield put(getPlates(page, filters));
  } catch (error) {
    yield call(errorHandler, error, assignPlateMukebError);
  }
}

function* cancelPlateSaga(action) {
  try {
    const { plateId, page, filters } = action.payload;
    yield call(cancelPlateAsync, plateId);
    yield put(cancelPlateSuccess('پلاک با موفقیت لغو شد.'));
    yield put(getPlates(page, filters));
  } catch (error) {
    yield call(errorHandler, error, cancelPlateError);
  }
}

function* exportPlatesSaga(action) {
  try {
    const { filters = {}, type = 'excel' } = action.payload;
    const data = yield call(exportPlatesAsync, filters, type);

    if (type === 'excel') {
      yield call(downloadBlob, data, 'plates.xlsx');
      yield put(exportPlatesExcelSuccess('خروجی اکسل با موفقیت ایجاد شد.'));
    } else if (type === 'json') {
      yield put(exportPlatesExcelSuccess('خروجی JSON با موفقیت دریافت شد.'));
      // Optionally handle JSON data here or dispatch another action if needed
    }
  } catch (error) {
    yield call(errorHandler, error, exportPlatesExcelError);
  }
}

function* watchGetPlates() {
  yield takeLatest(GET_PLATES, getPlatesSaga);
}

function* watchAssignPlateMukeb() {
  yield takeLatest(ASSIGN_PLATE_MUKEB, assignPlateMukebSaga);
}

function* watchCancelPlate() {
  yield takeLatest(CANCEL_PLATE, cancelPlateSaga);
}

function* watchExportPlatesExcel() {
  yield takeLatest(EXPORT_PLATES_EXCEL, exportPlatesSaga);
}

export default function* rootSaga() {
  yield all([
    fork(watchGetPlates),
    fork(watchAssignPlateMukeb),
    fork(watchCancelPlate),
    fork(watchExportPlatesExcel),
  ]);
}
